import React, { useState, useContext, useEffect } from 'react'
import AuthContext from '@/product/context/auth/authContext'
import './Footer.css'
import AutopltContext from '@/product/context/autopilot/autopltContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FOOTER_LOGO, SITE_NAME, SITE_URL } from '@/utils'
import FooterLinks from './footerLinks'
import { footerData } from './footerData'
import { Link } from 'react-router-dom'
import CustomCommonContext from '../../../../custom/context/common/commonContext'

const Footer = () => {
    const autopltContext = useContext(AutopltContext)
    const authContext = useContext(AuthContext)
    const { addCustomer, responseStatus: responseStatusAutoPlt } = autopltContext
    const customCommonContext = useContext(CustomCommonContext)
    const { allHeaderMenus } = customCommonContext

    const { user, isAuthenticated } = authContext

    const [footerMenus, setFooterMenus] = useState({
        id: 0,
        footerTitle: 'Custom Menu',
        lists: [],
    })

    const validationArray = Yup.object({
        email: Yup.string().email('Invalid email format').required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            addCustomer(values)
        },
    })

    const subscribe = [
        {
            label: 'Subscribe to our mailing list',
            placeholder: 'Enter your email address',
            class: 'subsInp',
            type: 'text',
            variant: 'filled',
            name: 'email',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (responseStatusAutoPlt) {
            if (responseStatusAutoPlt.from === 'addCustomer') {
                if (responseStatusAutoPlt.status === 'success') {
                    formik.values.email = ''
                }
            }
        }
    }, [responseStatusAutoPlt])

    useEffect(() => {
        if (allHeaderMenus?.length) {
            const dynamicFooterLists = allHeaderMenus
                .filter((menu) => menu.type === 'footer')
                .map((menu) => ({
                    id: menu.id,
                    title: menu.menu_name,
                    path: menu.menu_value,
                    isLoggedIn: false,
                    external: true,
                }))
            // const _footerData = {
            //     id: 0,
            //     footerTitle: 'Custom Menu',
            //     lists: dynamicFooterLists,
            // }
            // setFooterMenus(_footerData)
        }
    }, [allHeaderMenus])

    return (
        <footer className="noPrint">
            <div className="customContainer">
                <div className="row m-auto">
                    <div className="col-md-3 col-12">
                        <Link to="/">
                            <img
                                src={FOOTER_LOGO}
                                alt={SITE_NAME}
                                className="footer-logo d-flex m-auto"
                            />
                        </Link>
                        <p className="footCopyright mx-auto text-center" dir="ltr">
                            Copyright © {new Date().getFullYear()} {SITE_URL}{' '}
                            {'All rights reserved'}.
                        </p>
                    </div>
                    <div className="col-md-9 col-12">
                        <div className="row justify-content-between">
                            {footerMenus?.lists?.length ? <FooterLinks data={footerMenus} /> : null}
                            {footerData.map((data) => (
                                <>
                                    <FooterLinks data={data} />
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
